module.exports = __webpack_public_path__ + "img/comments.d6e01fdb.svg";